import { useEffect } from "react";

export const META_PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID || "";

type ReturnType = {
  track: (event: string, params?: Record<string, unknown>) => void;
};

export default (pixelId?: string): ReturnType => {
  useEffect(() => {
    if (!pixelId) {
      return;
    }

    let script: HTMLScriptElement | null = null;
    if (!document.querySelector('script[src*="connect.facebook.net"]')) {
      script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.appendChild(script);
    }

    const setupScript = document.createElement("script");
    setupScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[]}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${pixelId}');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(setupScript);

    return () => {
      if (script) {
        document.head.removeChild(script);
      }
      document.head.removeChild(setupScript);
    };
  }, [pixelId]);

  const track = (event: string, params?: Record<string, unknown>) => {
    const windowWithFbq = window as Window & {
      fbq?: (
        command: string,
        event: string,
        params?: Record<string, unknown>,
      ) => void;
    };

    if (typeof windowWithFbq.fbq === "function") {
      windowWithFbq.fbq("track", event, params);
    } else {
      console.error(
        "window.fbq function is not defined. Meta Pixel event could not be sent.",
      );
    }
  };

  return { track };
};
